// canvas-confetti v1.9.4 built on 2025-10-25T05:14:56.640Z
!(function (window, module) {
// source content
/* globals Map */

(function main(global, module, isWorker, workerSize) {
  var canUseWorker = !!(
    global.Worker &&
    global.Blob &&
    global.Promise &&
    global.OffscreenCanvas &&
    global.OffscreenCanvasRenderingContext2D &&
    global.HTMLCanvasElement &&
    global.HTMLCanvasElement.prototype.transferControlToOffscreen &&
    global.URL &&
    global.URL.createObjectURL);

  var canUsePaths = typeof Path2D === 'function' && typeof DOMMatrix === 'function';
  var canDrawBitmap = (function () {
    // this mostly supports ssr
    if (!global.OffscreenCanvas) {
      return false;
    }

    try {
      var canvas = new OffscreenCanvas(1, 1);
      var ctx = canvas.getContext('2d');
      ctx.fillRect(0, 0, 1, 1);
      var bitmap = canvas.transferToImageBitmap();
      ctx.createPattern(bitmap, 'no-repeat');
    } catch (e) {
      return false;
    }

    return true;
  })();

  function noop() {}

  // create a promise if it exists, otherwise, just
  // call the function directly
  function promise(func) {
    var ModulePromise = module.exports.Promise;
    var Prom = ModulePromise !== void 0 ? ModulePromise : global.Promise;

    if (typeof Prom === 'function') {
      return new Prom(func);
    }

    func(noop, noop);

    return null;
  }

  var bitmapMapper = (function (skipTransform, map) {
    // see https://github.com/catdad/canvas-confetti/issues/209
    // creating canvases is actually pretty expensive, so we should create a
    // 1:1 map for bitmap:canvas, so that we can animate the confetti in
    // a performant manner, but also not store them forever so that we don't
    // have a memory leak
    return {
      transform: function(bitmap) {
        if (skipTransform) {
          return bitmap;
        }

        if (map.has(bitmap)) {
          return map.get(bitmap);
        }

        var canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
        var ctx = canvas.getContext('2d');
        ctx.drawImage(bitmap, 0, 0);

        map.set(bitmap, canvas);

        return canvas;
      },
      clear: function () {
        map.clear();
      }
    };
  })(canDrawBitmap, new Map());

  var raf = (function () {
    var TIME = Math.floor(1000 / 60);
    var frame, cancel;
    var frames = {};
    var lastFrameTime = 0;

    if (typeof requestAnimationFrame === 'function' && typeof cancelAnimationFrame === 'function') {
      frame = function (cb) {
        var id = Math.random();

        frames[id] = requestAnimationFrame(function onFrame(time) {
          if (lastFrameTime === time || lastFrameTime + TIME - 1 < time) {
            lastFrameTime = time;
            delete frames[id];

            cb();
          } else {
            frames[id] = requestAnimationFrame(onFrame);
          }
        });

        return id;
      };
      cancel = function (id) {
        if (frames[id]) {
          cancelAnimationFrame(frames[id]);
        }
      };
    } else {
      frame = function (cb) {
        return setTimeout(cb, TIME);
      };
      cancel = function (timer) {
        return clearTimeout(timer);
      };
    }

    return { frame: frame, cancel: cancel };
  }());

  var getWorker = (function () {
    var worker;
    var prom;
    var resolves = {};

    function decorate(worker) {
      function execute(options, callback) {
        worker.postMessage({ options: options || {}, callback: callback });
      }
      worker.init = function initWorker(canvas) {
        var offscreen = canvas.transferControlToOffscreen();
        worker.postMessage({ canvas: offscreen }, [offscreen]);
      };

      worker.fire = function fireWorker(options, size, done) {
        if (prom) {
          execute(options, null);
          return prom;
        }

        var id = Math.random().toString(36).slice(2);

        prom = promise(function (resolve) {
          function workerDone(msg) {
            if (msg.data.callback !== id) {
              return;
            }

            delete resolves[id];
            worker.removeEventListener('message', workerDone);

            prom = null;

            bitmapMapper.clear();

            done();
            resolve();
          }

          worker.addEventListener('message', workerDone);
          execute(options, id);

          resolves[id] = workerDone.bind(null, { data: { callback: id }});
        });

        return prom;
      };

      worker.reset = function resetWorker() {
        worker.postMessage({ reset: true });

        for (var id in resolves) {
          resolves[id]();
          delete resolves[id];
        }
      };
    }

    return function () {
      if (worker) {
        return worker;
      }

      if (!isWorker && canUseWorker) {
        var code = [
          'var CONFETTI, SIZE = {}, module = {};',
          '(' + main.toString() + ')(this, module, true, SIZE);',
          'onmessage = function(msg) {',
          '  if (msg.data.options) {',
          '    CONFETTI(msg.data.options).then(function () {',
          '      if (msg.data.callback) {',
          '        postMessage({ callback: msg.data.callback });',
          '      }',
          '    });',
          '  } else if (msg.data.reset) {',
          '    CONFETTI && CONFETTI.reset();',
          '  } else if (msg.data.resize) {',
          '    SIZE.width = msg.data.resize.width;',
          '    SIZE.height = msg.data.resize.height;',
          '  } else if (msg.data.canvas) {',
          '    SIZE.width = msg.data.canvas.width;',
          '    SIZE.height = msg.data.canvas.height;',
          '    CONFETTI = module.exports.create(msg.data.canvas);',
          '  }',
          '}',
        ].join('\n');
        try {
          worker = new Worker(URL.createObjectURL(new Blob([code])));
        } catch (e) {
          // eslint-disable-next-line no-console
          typeof console !== 'undefined' && typeof console.warn === 'function' ? console.warn('🎊 Could not load worker', e) : null;

          return null;
        }

        decorate(worker);
      }

      return worker;
    };
  })();

  var defaults = {
    particleCount: 50,
    angle: 90,
    spread: 45,
    startVelocity: 45,
    decay: 0.9,
    gravity: 1,
    drift: 0,
    ticks: 200,
    x: 0.5,
    y: 0.5,
    shapes: ['square', 'circle'],
    zIndex: 100,
    colors: [
      '#26ccff',
      '#a25afd',
      '#ff5e7e',
      '#88ff5a',
      '#fcff42',
      '#ffa62d',
      '#ff36ff'
    ],
    // probably should be true, but back-compat
    disableForReducedMotion: false,
    scalar: 1
  };

  function convert(val, transform) {
    return transform ? transform(val) : val;
  }

  function isOk(val) {
    return !(val === null || val === undefined);
  }

  function prop(options, name, transform) {
    return convert(
      options && isOk(options[name]) ? options[name] : defaults[name],
      transform
    );
  }

  function onlyPositiveInt(number){
    return number < 0 ? 0 : Math.floor(number);
  }

  function randomInt(min, max) {
    // [min, max)
    return Math.floor(Math.random() * (max - min)) + min;
  }

  function toDecimal(str) {
    return parseInt(str, 16);
  }

  function colorsToRgb(colors) {
    return colors.map(hexToRgb);
  }

  function hexToRgb(str) {
    var val = String(str).replace(/[^0-9a-f]/gi, '');

    if (val.length < 6) {
        val = val[0]+val[0]+val[1]+val[1]+val[2]+val[2];
    }

    return {
      r: toDecimal(val.substring(0,2)),
      g: toDecimal(val.substring(2,4)),
      b: toDecimal(val.substring(4,6))
    };
  }

  function getOrigin(options) {
    var origin = prop(options, 'origin', Object);
    origin.x = prop(origin, 'x', Number);
    origin.y = prop(origin, 'y', Number);

    return origin;
  }

  function setCanvasWindowSize(canvas) {
    canvas.width = document.documentElement.clientWidth;
    canvas.height = document.documentElement.clientHeight;
  }

  function setCanvasRectSize(canvas) {
    var rect = canvas.getBoundingClientRect();
    canvas.width = rect.width;
    canvas.height = rect.height;
  }

  function getCanvas(zIndex) {
    var canvas = document.createElement('canvas');

    canvas.style.position = 'fixed';
    canvas.style.top = '0px';
    canvas.style.left = '0px';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = zIndex;

    return canvas;
  }

  function ellipse(context, x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
    context.save();
    context.translate(x, y);
    context.rotate(rotation);
    context.scale(radiusX, radiusY);
    context.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
    context.restore();
  }

  function randomPhysics(opts) {
    var radAngle = opts.angle * (Math.PI / 180);
    var radSpread = opts.spread * (Math.PI / 180);

    return {
      x: opts.x,
      y: opts.y,
      wobble: Math.random() * 10,
      wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
      velocity: (opts.startVelocity * 0.5) + (Math.random() * opts.startVelocity),
      angle2D: -radAngle + ((0.5 * radSpread) - (Math.random() * radSpread)),
      tiltAngle: (Math.random() * (0.75 - 0.25) + 0.25) * Math.PI,
      color: opts.color,
      shape: opts.shape,
      tick: 0,
      totalTicks: opts.ticks,
      decay: opts.decay,
      drift: opts.drift,
      random: Math.random() + 2,
      tiltSin: 0,
      tiltCos: 0,
      wobbleX: 0,
      wobbleY: 0,
      gravity: opts.gravity * 3,
      ovalScalar: 0.6,
      scalar: opts.scalar,
      flat: opts.flat
    };
  }

  function updateFetti(context, fetti) {
    fetti.x += Math.cos(fetti.angle2D) * fetti.velocity + fetti.drift;
    fetti.y += Math.sin(fetti.angle2D) * fetti.velocity + fetti.gravity;
    fetti.velocity *= fetti.decay;

    if (fetti.flat) {
      fetti.wobble = 0;
      fetti.wobbleX = fetti.x + (10 * fetti.scalar);
      fetti.wobbleY = fetti.y + (10 * fetti.scalar);

      fetti.tiltSin = 0;
      fetti.tiltCos = 0;
      fetti.random = 1;
    } else {
      fetti.wobble += fetti.wobbleSpeed;
      fetti.wobbleX = fetti.x + ((10 * fetti.scalar) * Math.cos(fetti.wobble));
      fetti.wobbleY = fetti.y + ((10 * fetti.scalar) * Math.sin(fetti.wobble));

      fetti.tiltAngle += 0.1;
      fetti.tiltSin = Math.sin(fetti.tiltAngle);
      fetti.tiltCos = Math.cos(fetti.tiltAngle);
      fetti.random = Math.random() + 2;
    }

    var progress = (fetti.tick++) / fetti.totalTicks;

    var x1 = fetti.x + (fetti.random * fetti.tiltCos);
    var y1 = fetti.y + (fetti.random * fetti.tiltSin);
    var x2 = fetti.wobbleX + (fetti.random * fetti.tiltCos);
    var y2 = fetti.wobbleY + (fetti.random * fetti.tiltSin);

    context.fillStyle = 'rgba(' + fetti.color.r + ', ' + fetti.color.g + ', ' + fetti.color.b + ', ' + (1 - progress) + ')';

    context.beginPath();

    if (canUsePaths && fetti.shape.type === 'path' && typeof fetti.shape.path === 'string' && Array.isArray(fetti.shape.matrix)) {
      context.fill(transformPath2D(
        fetti.shape.path,
        fetti.shape.matrix,
        fetti.x,
        fetti.y,
        Math.abs(x2 - x1) * 0.1,
        Math.abs(y2 - y1) * 0.1,
        Math.PI / 10 * fetti.wobble
      ));
    } else if (fetti.shape.type === 'bitmap') {
      var rotation = Math.PI / 10 * fetti.wobble;
      var scaleX = Math.abs(x2 - x1) * 0.1;
      var scaleY = Math.abs(y2 - y1) * 0.1;
      var width = fetti.shape.bitmap.width * fetti.scalar;
      var height = fetti.shape.bitmap.height * fetti.scalar;

      var matrix = new DOMMatrix([
        Math.cos(rotation) * scaleX,
        Math.sin(rotation) * scaleX,
        -Math.sin(rotation) * scaleY,
        Math.cos(rotation) * scaleY,
        fetti.x,
        fetti.y
      ]);

      // apply the transform matrix from the confetti shape
      matrix.multiplySelf(new DOMMatrix(fetti.shape.matrix));

      var pattern = context.createPattern(bitmapMapper.transform(fetti.shape.bitmap), 'no-repeat');
      pattern.setTransform(matrix);

      context.globalAlpha = (1 - progress);
      context.fillStyle = pattern;
      context.fillRect(
        fetti.x - (width / 2),
        fetti.y - (height / 2),
        width,
        height
      );
      context.globalAlpha = 1;
    } else if (fetti.shape === 'circle') {
      context.ellipse ?
        context.ellipse(fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI) :
        ellipse(context, fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI);
    } else if (fetti.shape === 'star') {
      var rot = Math.PI / 2 * 3;
      var innerRadius = 4 * fetti.scalar;
      var outerRadius = 8 * fetti.scalar;
      var x = fetti.x;
      var y = fetti.y;
      var spikes = 5;
      var step = Math.PI / spikes;

      while (spikes--) {
        x = fetti.x + Math.cos(rot) * outerRadius;
        y = fetti.y + Math.sin(rot) * outerRadius;
        context.lineTo(x, y);
        rot += step;

        x = fetti.x + Math.cos(rot) * innerRadius;
        y = fetti.y + Math.sin(rot) * innerRadius;
        context.lineTo(x, y);
        rot += step;
      }
    } else {
      context.moveTo(Math.floor(fetti.x), Math.floor(fetti.y));
      context.lineTo(Math.floor(fetti.wobbleX), Math.floor(y1));
      context.lineTo(Math.floor(x2), Math.floor(y2));
      context.lineTo(Math.floor(x1), Math.floor(fetti.wobbleY));
    }

    context.closePath();
    context.fill();

    return fetti.tick < fetti.totalTicks;
  }

  function animate(canvas, fettis, resizer, size, done) {
    var animatingFettis = fettis.slice();
    var context = canvas.getContext('2d');
    var animationFrame;
    var destroy;

    var prom = promise(function (resolve) {
      function onDone() {
        animationFrame = destroy = null;

        context.clearRect(0, 0, size.width, size.height);
        bitmapMapper.clear();

        done();
        resolve();
      }

      function update() {
        if (isWorker && !(size.width === workerSize.width && size.height === workerSize.height)) {
          size.width = canvas.width = workerSize.width;
          size.height = canvas.height = workerSize.height;
        }

        if (!size.width && !size.height) {
          resizer(canvas);
          size.width = canvas.width;
          size.height = canvas.height;
        }

        context.clearRect(0, 0, size.width, size.height);

        animatingFettis = animatingFettis.filter(function (fetti) {
          return updateFetti(context, fetti);
        });

        if (animatingFettis.length) {
          animationFrame = raf.frame(update);
        } else {
          onDone();
        }
      }

      animationFrame = raf.frame(update);
      destroy = onDone;
    });

    return {
      addFettis: function (fettis) {
        animatingFettis = animatingFettis.concat(fettis);

        return prom;
      },
      canvas: canvas,
      promise: prom,
      reset: function () {
        if (animationFrame) {
          raf.cancel(animationFrame);
        }

        if (destroy) {
          destroy();
        }
      }
    };
  }

  function confettiCannon(canvas, globalOpts) {
    var isLibCanvas = !canvas;
    var allowResize = !!prop(globalOpts || {}, 'resize');
    var hasResizeEventRegistered = false;
    var globalDisableForReducedMotion = prop(globalOpts, 'disableForReducedMotion', Boolean);
    var shouldUseWorker = canUseWorker && !!prop(globalOpts || {}, 'useWorker');
    var worker = shouldUseWorker ? getWorker() : null;
    var resizer = isLibCanvas ? setCanvasWindowSize : setCanvasRectSize;
    var initialized = (canvas && worker) ? !!canvas.__confetti_initialized : false;
    var preferLessMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion)').matches;
    var animationObj;

    function fireLocal(options, size, done) {
      var particleCount = prop(options, 'particleCount', onlyPositiveInt);
      var angle = prop(options, 'angle', Number);
      var spread = prop(options, 'spread', Number);
      var startVelocity = prop(options, 'startVelocity', Number);
      var decay = prop(options, 'decay', Number);
      var gravity = prop(options, 'gravity', Number);
      var drift = prop(options, 'drift', Number);
      var colors = prop(options, 'colors', colorsToRgb);
      var ticks = prop(options, 'ticks', Number);
      var shapes = prop(options, 'shapes');
      var scalar = prop(options, 'scalar');
      var flat = !!prop(options, 'flat');
      var origin = getOrigin(options);

      var temp = particleCount;
      var fettis = [];

      var startX = canvas.width * origin.x;
      var startY = canvas.height * origin.y;

      while (temp--) {
        fettis.push(
          randomPhysics({
            x: startX,
            y: startY,
            angle: angle,
            spread: spread,
            startVelocity: startVelocity,
            color: colors[temp % colors.length],
            shape: shapes[randomInt(0, shapes.length)],
            ticks: ticks,
            decay: decay,
            gravity: gravity,
            drift: drift,
            scalar: scalar,
            flat: flat
          })
        );
      }

      // if we have a previous canvas already animating,
      // add to it
      if (animationObj) {
        return animationObj.addFettis(fettis);
      }

      animationObj = animate(canvas, fettis, resizer, size , done);

      return animationObj.promise;
    }

    function fire(options) {
      var disableForReducedMotion = globalDisableForReducedMotion || prop(options, 'disableForReducedMotion', Boolean);
      var zIndex = prop(options, 'zIndex', Number);

      if (disableForReducedMotion && preferLessMotion) {
        return promise(function (resolve) {
          resolve();
        });
      }

      if (isLibCanvas && animationObj) {
        // use existing canvas from in-progress animation
        canvas = animationObj.canvas;
      } else if (isLibCanvas && !canvas) {
        // create and initialize a new canvas
        canvas = getCanvas(zIndex);
        document.body.appendChild(canvas);
      }

      if (allowResize && !initialized) {
        // initialize the size of a user-supplied canvas
        resizer(canvas);
      }

      var size = {
        width: canvas.width,
        height: canvas.height
      };

      if (worker && !initialized) {
        worker.init(canvas);
      }

      initialized = true;

      if (worker) {
        canvas.__confetti_initialized = true;
      }

      function onResize() {
        if (worker) {
          // TODO this really shouldn't be immediate, because it is expensive
          var obj = {
            getBoundingClientRect: function () {
              if (!isLibCanvas) {
                return canvas.getBoundingClientRect();
              }
            }
          };

          resizer(obj);

          worker.postMessage({
            resize: {
              width: obj.width,
              height: obj.height
            }
          });
          return;
        }

        // don't actually query the size here, since this
        // can execute frequently and rapidly
        size.width = size.height = null;
      }

      function done() {
        animationObj = null;

        if (allowResize) {
          hasResizeEventRegistered = false;
          global.removeEventListener('resize', onResize);
        }

        if (isLibCanvas && canvas) {
          if (document.body.contains(canvas)) {
            document.body.removeChild(canvas);
          }
          canvas = null;
          initialized = false;
        }
      }

      if (allowResize && !hasResizeEventRegistered) {
        hasResizeEventRegistered = true;
        global.addEventListener('resize', onResize, false);
      }

      if (worker) {
        return worker.fire(options, size, done);
      }

      return fireLocal(options, size, done);
    }

    fire.reset = function () {
      if (worker) {
        worker.reset();
      }

      if (animationObj) {
        animationObj.reset();
      }
    };

    return fire;
  }

  // Make default export lazy to defer worker creation until called.
  var defaultFire;
  function getDefaultFire() {
    if (!defaultFire) {
      defaultFire = confettiCannon(null, { useWorker: true, resize: true });
    }
    return defaultFire;
  }

  function transformPath2D(pathString, pathMatrix, x, y, scaleX, scaleY, rotation) {
    var path2d = new Path2D(pathString);

    var t1 = new Path2D();
    t1.addPath(path2d, new DOMMatrix(pathMatrix));

    var t2 = new Path2D();
    // see https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix/DOMMatrix
    t2.addPath(t1, new DOMMatrix([
      Math.cos(rotation) * scaleX,
      Math.sin(rotation) * scaleX,
      -Math.sin(rotation) * scaleY,
      Math.cos(rotation) * scaleY,
      x,
      y
    ]));

    return t2;
  }

  function shapeFromPath(pathData) {
    if (!canUsePaths) {
      throw new Error('path confetti are not supported in this browser');
    }

    var path, matrix;

    if (typeof pathData === 'string') {
      path = pathData;
    } else {
      path = pathData.path;
      matrix = pathData.matrix;
    }

    var path2d = new Path2D(path);
    var tempCanvas = document.createElement('canvas');
    var tempCtx = tempCanvas.getContext('2d');

    if (!matrix) {
      // attempt to figure out the width of the path, up to 1000x1000
      var maxSize = 1000;
      var minX = maxSize;
      var minY = maxSize;
      var maxX = 0;
      var maxY = 0;
      var width, height;

      // do some line skipping... this is faster than checking
      // every pixel and will be mostly still correct
      for (var x = 0; x < maxSize; x += 2) {
        for (var y = 0; y < maxSize; y += 2) {
          if (tempCtx.isPointInPath(path2d, x, y, 'nonzero')) {
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          }
        }
      }

      width = maxX - minX;
      height = maxY - minY;

      var maxDesiredSize = 10;
      var scale = Math.min(maxDesiredSize/width, maxDesiredSize/height);

      matrix = [
        scale, 0, 0, scale,
        -Math.round((width/2) + minX) * scale,
        -Math.round((height/2) + minY) * scale
      ];
    }

    return {
      type: 'path',
      path: path,
      matrix: matrix
    };
  }

  function shapeFromText(textData) {
    var text,
        scalar = 1,
        color = '#000000',
        // see https://nolanlawson.com/2022/04/08/the-struggle-of-using-native-emoji-on-the-web/
        fontFamily = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';

    if (typeof textData === 'string') {
      text = textData;
    } else {
      text = textData.text;
      scalar = 'scalar' in textData ? textData.scalar : scalar;
      fontFamily = 'fontFamily' in textData ? textData.fontFamily : fontFamily;
      color = 'color' in textData ? textData.color : color;
    }

    // all other confetti are 10 pixels,
    // so this pixel size is the de-facto 100% scale confetti
    var fontSize = 10 * scalar;
    var font = '' + fontSize + 'px ' + fontFamily;

    var canvas = new OffscreenCanvas(fontSize, fontSize);
    var ctx = canvas.getContext('2d');

    ctx.font = font;
    var size = ctx.measureText(text);
    var width = Math.ceil(size.actualBoundingBoxRight + size.actualBoundingBoxLeft);
    var height = Math.ceil(size.actualBoundingBoxAscent + size.actualBoundingBoxDescent);

    var padding = 2;
    var x = size.actualBoundingBoxLeft + padding;
    var y = size.actualBoundingBoxAscent + padding;
    width += padding + padding;
    height += padding + padding;

    canvas = new OffscreenCanvas(width, height);
    ctx = canvas.getContext('2d');
    ctx.font = font;
    ctx.fillStyle = color;

    ctx.fillText(text, x, y);

    var scale = 1 / scalar;

    return {
      type: 'bitmap',
      // TODO these probably need to be transfered for workers
      bitmap: canvas.transferToImageBitmap(),
      matrix: [scale, 0, 0, scale, -width * scale / 2, -height * scale / 2]
    };
  }

  module.exports = function() {
    return getDefaultFire().apply(this, arguments);
  };
  module.exports.reset = function() {
    getDefaultFire().reset();
  };
  module.exports.create = confettiCannon;
  module.exports.shapeFromPath = shapeFromPath;
  module.exports.shapeFromText = shapeFromText;
}((function () {
  if (typeof window !== 'undefined') {
    return window;
  }

  if (typeof self !== 'undefined') {
    return self;
  }

  return this || {};
})(), module, false));

// end source content

  window.confetti = module.exports;
}(window, {}));
;
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ─────────────────────────────────────────────────────────────
     0. CONFIG
     In Shopify these come from the section settings, via data-
     attributes on .bm-landing. In the standalone HTML mock the
     wrapper is absent and the defaults below apply — so both
     builds run the same code path.
     ───────────────────────────────────────────────────────────── */
  var root = document.querySelector('.bm-landing');
  function cfg(name, fallback) {
    if (!root) return fallback;
    var v = root.getAttribute('data-' + name);
    return (v === null || v === '') ? fallback : v;
  }

  /* ─────────────────────────────────────────────────────────────
     1. SERVICE AREA
     ▸▸ These are DEMO values. ◂◂ Replace them in the section
     settings, or better: point checkZip() at a real
     GET /check-zip?zip=NNNNN so there's one source of truth.
     ───────────────────────────────────────────────────────────── */
  var DEMO_ZIPS = [
    /* Lifted verbatim from sections/shop-sample-packs.liquid (allowedZipCodes).
       THREE copies of this list now exist in the theme (also tryit-wizard.liquid,
       which is already out of sync). Ship GET /check-zip to make it one. */
    '22003','22030','20171','22015','20170','22079','22033','22042','22309','22031',
    '22306','22032','22153','22101','22310','20191','22315','22152','22041','22150',
    '22312','22102','20121','22182','22043','20151','20107','22044','22207','22066',
    '20147','20148','20152','20166','20164','20165','20190','20194','20105','20175',
    '20176','20158','20197','20129','20109','20110','20111','20112','20120','20124',
    '20136','20143','20155','20169','20180','20181','22046','22060','22124','22151',
    '22180','22181','22201','22202','22203','22204','22205','22206','22209','22213',
    '22301','22302','22303','22304','22305','22307','22308','22311','22314','21777',
    '21701','21702','21703','21704','21705','21709',
    '20001','20002','20003','20004','20005','20006','20007','20008','20009','20010',
    '20011','20012','20015','20016','20017','20018','20019','20020','20024','20032',
    '20036','20037','20045','20052','20053','20057','20059','20064','20132'
  ];
  var SERVICE_ZIPS = String(cfg('service-zips', DEMO_ZIPS.join(',')))
    .split(',').map(function (z) { return z.trim(); }).filter(Boolean);

  /* ─────────────────────────────────────────────────────────────
     2. THE OFFER — a calm, standing offer. No countdown, no urgency
     machinery: free delivery for life, for DMV residents, claimed by
     checking a zip. The only state is the kill switch below.
     ───────────────────────────────────────────────────────────── */
  var OFFER_LIVE = String(cfg('offer-live', 'true')) !== 'false';
  var bar = document.getElementById('offerbar');
  var offerText = document.getElementById('offertext');
  var panel = document.getElementById('offerpanel');
  var stickyBar = document.getElementById('stickycta');

  function setText(el, t) { if (el) el.textContent = t; }

  /* Kill switch: untick "Offer is running" in the theme editor and every
     trace of the free-delivery claim comes off the page. */
  if (!OFFER_LIVE) {
    if (bar) bar.setAttribute('data-state', 'expired');
    if (offerText) offerText.innerHTML = '<svg class="lic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="4" r="2"/><circle cx="18" cy="8" r="2"/><circle cx="20" cy="16" r="2"/><path d="M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"/></svg> <b>Local delivery</b> across the DMV';
    if (stickyBar) stickyBar.setAttribute('data-state', 'expired');
    if (panel) {
      panel.setAttribute('data-state', 'expired');
      setText(document.getElementById('opkicker'), 'No offer running right now');
      var head = document.getElementById('ophead');
      if (head) head.innerHTML = 'Still delivering <em>across the DMV</em>';
      setText(document.getElementById('opfoot'),
        'Fresh, whole-food meals cooked in our Leesburg kitchen — delivered across the DMV.');
    }
    var ctas = document.querySelectorAll('[data-cta-label]');
    for (var j = 0; j < ctas.length; j++) ctas[j].textContent = "See your dog's plan";
  }

  function serviceable(zip) {
    // Swap this body for a fetch() against your /check-zip endpoint.
    return SERVICE_ZIPS.indexOf(zip) !== -1;
  }

  /* ─────────────────────────────────────────────────────────────
     5. REVEAL + STICKY CTA
     ───────────────────────────────────────────────────────────── */
  var rise = document.querySelectorAll('.rise');
  if (!('IntersectionObserver' in window) || reduce) {
    for (var i = 0; i < rise.length; i++) rise[i].classList.add('in');
  } else {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); ro.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    for (var j = 0; j < rise.length; j++) ro.observe(rise[j]);
  }

  /* ─────────────────────────────────────────────────────────────
     ATTRIBUTION + OFFER TRACKING
     · trackParams captures the ad-click identity (utm_*, fbclid,
       igshid…) from the landing URL once, and withTracking() carries
       it onto every link into the meal plan builder — so a visitor
       who arrived from an Instagram ad is still attributable inside
       /pages/explore and at checkout.
     · trackOfferCheck() fires one beacon at /track-offer-claim when a
       zip is checked against the offer, which posts a line to Slack.
       Strictly fire-and-forget: any failure is swallowed, the claim
       flow never waits on it.
     ───────────────────────────────────────────────────────────── */
  var TRACK_ENDPOINT = 'https://api.bogeysmix.com/track-offer-claim';
  var TRACK_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content',
                    'utm_term', 'fbclid', 'igshid', 'igsh', 'ttclid', 'gclid'];
  var trackParams = (function () {
    var out = {};
    try {
      var q = new URLSearchParams(window.location.search);
      for (var i = 0; i < TRACK_KEYS.length; i++) {
        var v = q.get(TRACK_KEYS[i]);
        if (v) out[TRACK_KEYS[i]] = v.slice(0, 200);
      }
    } catch (e) { /* no URLSearchParams — skip attribution, never break */ }
    return out;
  })();
  function withTracking(url) {
    var ks = Object.keys(trackParams);
    if (!ks.length) return url;
    var extra = ks.map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(trackParams[k]);
    }).join('&');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + extra;
  }
  /* every route into the builder carries the attribution forward */
  if (Object.keys(trackParams).length) {
    var wizLinks = document.querySelectorAll('a[href^="/pages/explore"]');
    for (var wl = 0; wl < wizLinks.length; wl++) {
      wizLinks[wl].setAttribute('href', withTracking(wizLinks[wl].getAttribute('href')));
    }
  }
  function trackOfferCheck(zip, eligible) {
    try {
      if (!window.fetch) return;
      window.fetch(TRACK_ENDPOINT, {
        method: 'POST', mode: 'cors', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ zip: zip, eligible: !!eligible,
          page: window.location.pathname,
          referrer: document.referrer || '', utm: trackParams })
      })['catch'](function () {});
    } catch (e) { /* tracking must never break the claim */ }
  }

  /* ─────────────────────────────────────────────────────────────
     IN-PANEL CLAIM — the hero CTA validates the zip right where it
     is, then goes straight into the wizard with ?zip= prefilled.
     No scrolling anywhere. Out-of-area gets the topper fallback.
     ───────────────────────────────────────────────────────────── */
  var celebrate;   /* assigned below; shared with the magic-words egg */
  var claimForm = document.getElementById('opclaim');
  var claimIn = document.getElementById('opzipin');
  var claimMsg = document.getElementById('opclaimmsg');
  if (claimForm && claimIn && claimMsg) {
    var claimBtn = claimForm.querySelector('.op-claimbtn');
    var goBtn = document.getElementById('opgo');
    var claimedZip = null;

    /* canvas-confetti (vendored into this file), fired from the claim button.
       disableForReducedMotion makes the library a no-op under reduced motion. */
    celebrate = function () {
      if (!window.confetti) return;
      var src = (goBtn && !goBtn.hidden) ? goBtn : claimBtn;
      var r = src ? src.getBoundingClientRect() : null;
      var origin = (r && r.width > 0 && r.top > 0 && r.top < window.innerHeight)
        ? { x: (r.left + r.width / 2) / window.innerWidth,
             y: (r.top + r.height / 2) / window.innerHeight }
        : { x: 0.5, y: 0.55 };
      var brand = ['#FBF807', '#00A8FF', '#B3DDF6', '#EF3A30', '#ffffff'];
      window.confetti({ particleCount: 90, spread: 75, startVelocity: 38,
        origin: origin, colors: brand, disableForReducedMotion: true, zIndex: 2000 });
      window.setTimeout(function () {
        window.confetti({ particleCount: 50, spread: 110, startVelocity: 28, scalar: .9,
          origin: origin, colors: brand, disableForReducedMotion: true, zIndex: 2000 });
      }, 220);
    };

    claimIn.addEventListener('input', function () {
      this.value = this.value.replace(/[^0-9]/g, '').slice(0, 5);
      if (claimedZip && this.value !== claimedZip) {
        /* different zip being checked — back to the claim step */
        claimedZip = null;
        claimMsg.className = 'op-claimmsg'; claimMsg.textContent = '';
        if (goBtn) goBtn.hidden = true;
        if (claimBtn) claimBtn.hidden = false;
      }
    });
    claimForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var z = claimIn.value.trim();
      claimMsg.className = 'op-claimmsg';
      if (!/^[0-9]{5}$/.test(z)) {
        claimMsg.textContent = 'Pop in all five digits and we’ll check.';
        claimIn.focus();
        return;
      }
      if (serviceable(z)) {
        claimedZip = z;
        claimMsg.className = 'op-claimmsg ok';
        claimMsg.innerHTML = '<svg class="lic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5.8 11.3 2 22l10.7-3.79"/><path d="M4 3h.01"/><path d="M22 8h.01"/><path d="M15 2h.01"/><path d="M22 20h.01"/><path d="m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10"/><path d="m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17"/><path d="m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7"/><path d="M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"/></svg> You qualify! Free delivery for life is locked in for ' + z + '.';
        if (goBtn) {
          goBtn.href = withTracking('/pages/explore?zip=' + encodeURIComponent(z) + '&fdl=1');
          goBtn.hidden = false;
        }
        if (claimBtn) claimBtn.hidden = true;   /* claimed — the next step replaces it */
        celebrate();
        trackOfferCheck(z, true);
      } else {
        claimMsg.innerHTML = 'Not in ' + z + ' just yet — but we’re growing fast.' +
          '<span class="sub">Our delivery map keeps expanding across the DMV — check back soon.</span>';
        trackOfferCheck(z, false);
      }
    });
  }

  /* ─────────────────────────────────────────────────────────────
     INSTAGRAM REELS — reads newline/comma-separated reel URLs from
     the section setting. Real embeds via instagram.com/embed.js,
     lazy-loaded only when the carousel nears the viewport. With no
     URLs configured it shows branded placeholder slots; untick
     "Show the reels carousel" in the theme editor to hide it.
     ───────────────────────────────────────────────────────────── */
  var reelsTrack = document.getElementById('reelstrack');
  if (reelsTrack) {
    var reelsSec = document.getElementById('reels');
    if (String(cfg('show-reels', 'true')) === 'false') {
      if (reelsSec) reelsSec.hidden = true;
    } else {
      var reelUrls = String(cfg('reels', '')).split(/[\n,\s]+/)
        .map(function (t) { return t.trim().split('?')[0]; })  /* drop ?img_index etc — the embed wants the clean permalink */
        .filter(function (u) { return /^https:\/\/(www\.)?instagram\.com\//.test(u); });
      if (reelUrls.length) {
        for (var ri = 0; ri < reelUrls.length; ri++) {
          var cell = document.createElement('div');
          cell.className = 'reel';
          var bq = document.createElement('blockquote');
          bq.className = 'instagram-media';
          bq.setAttribute('data-instgrm-permalink', reelUrls[ri]);  /* setAttribute: never innerHTML — settings are user input */
          bq.setAttribute('data-instgrm-version', '14');
          cell.appendChild(bq);
          reelsTrack.appendChild(cell);
        }
        var loadEmbeds = function () {
          if (window.__bmIgLoaded) return;
          window.__bmIgLoaded = true;
          var sc = document.createElement('script');
          sc.async = true;
          sc.src = 'https://www.instagram.com/embed.js';
          document.body.appendChild(sc);
        };
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (en, obs) {
            if (!en[0].isIntersecting) return;
            obs.disconnect(); loadEmbeds();
          }, { rootMargin: '600px' }).observe(reelsTrack);
        } else {
          loadEmbeds();
        }
      } else {
        for (var pi = 0; pi < 3; pi++) {
          var ph = document.createElement('div');
          ph.className = 'reel ph';
          ph.innerHTML = '<span class="pawmark"><svg class="lic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="4" r="2"/><circle cx="18" cy="8" r="2"/><circle cx="20" cy="16" r="2"/><path d="M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"/></svg></span>' +
            '<p>Reel spot ' + (pi + 1) + '<br>Add Instagram links in the theme editor</p>';
          reelsTrack.appendChild(ph);
        }
      }
    }
  }

  /* ─────────────────────────────────────────────────────────────
     STAT COUNT-UP — "32" counts from 0 when it scrolls into view.
     Skipped under reduced motion and without IntersectionObserver,
     in which case the real number is simply already there.
     ───────────────────────────────────────────────────────────── */
  var statEl = document.querySelector('.statnum');
  if (statEl && !reduce && 'IntersectionObserver' in window) {
    var statTarget = parseInt(statEl.textContent, 10);
    if (isFinite(statTarget) && statTarget > 0) {
      statEl.textContent = '0';
      new IntersectionObserver(function (entries, obs) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        var t0 = null, dur = 1200;
        var step = function (ts) {
          if (t0 === null) t0 = ts;
          var k = Math.min(1, (ts - t0) / dur);
          var eased = 1 - Math.pow(1 - k, 3);
          statEl.textContent = String(Math.round(eased * statTarget));
          if (k < 1) window.requestAnimationFrame(step);
        };
        window.requestAnimationFrame(step);
      }, { threshold: 0.6 }).observe(statEl);
    }
  }

  /* ─────────────────────────────────────────────────────────────
     EASTER EGG — typing the offer's own name throws the party.
     Letters only, rolling buffer; digits and punctuation reset it,
     spaces are ignored. Works typed anywhere on the page, including
     into the zip field (whose digit filter hides the letters), and
     pasted into the zip field. Never navigates.
     ───────────────────────────────────────────────────────────── */
  var MAGIC = 'freedeliveryforlife';
  var typedBuf = '';
  function magicHit() {
    typedBuf = '';
    if (claimMsg) {
      claimMsg.className = 'op-claimmsg ok';
      claimMsg.innerHTML = '<svg class="lic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5.8 11.3 2 22l10.7-3.79"/><path d="M4 3h.01"/><path d="M22 8h.01"/><path d="M15 2h.01"/><path d="M22 20h.01"/><path d="m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10"/><path d="m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17"/><path d="m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7"/><path d="M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"/></svg> You said the magic words!';
    }
    if (celebrate) celebrate();
  }
  document.addEventListener('keydown', function (ev) {
    var k = ev.key;
    if (!k || k.length !== 1) return;
    k = k.toLowerCase();
    if (k === ' ') return;                       /* spaces don't break the spell */
    if (k < 'a' || k > 'z') { typedBuf = ''; return; }
    typedBuf = (typedBuf + k).slice(-MAGIC.length);
    if (typedBuf === MAGIC) magicHit();
  });
  if (claimIn) {
    claimIn.addEventListener('paste', function (ev) {
      var t = (ev.clipboardData && ev.clipboardData.getData('text')) || '';
      if (t.toLowerCase().replace(/[^a-z]/g, '') === MAGIC) magicHit();
    });
  }

  /* ─────────────────────────────────────────────────────────────
     PINNED HERO — SPIRAL SPOTLIGHT. The chips float in place from the
     start; while the photo is pinned, scroll hands each chip a turn:
     it travels a circular arc into the center of the image, scaled up
     to reading size, then arcs home as the next one sets off. Driven
     directly by scroll progress (no thresholds), so it's fluid and
     scrubs identically in both directions. Skipped under reduced
     motion and without JS — chips simply float.
     ───────────────────────────────────────────────────────────── */
  var pinWrap = document.getElementById('pinwrap');
  if (pinWrap && !reduce && 'requestAnimationFrame' in window) {
    document.documentElement.classList.add('bm-pin');

    /* Which chips take a center turn, in order. Hard-coded on purpose —
       edit this list to change the show; the pinned runway height adapts.
       0 = Made in Leesburg, VA   1 = Virginia-raised turkey
       2 = No fillers, ever       3 = Dogs actually love it
       e.g. [3] spotlights one, [0,1,2,3] gives every chip a turn. */
    var SPOTLIGHT = [3];

    var pinChips = [].slice.call(pinWrap.querySelectorAll('.floatchip'));
    /* runway scales with the show: ~60vh of scroll per spotlighted chip —
       generous, because nearly half of each segment is the HOLD, where the
       chip sticks at center while you keep scrolling */
    pinWrap.style.setProperty('--pinrun', (SPOTLIGHT.length * 60) + 'vh');
    var heroImg = pinWrap.querySelector('.hero-shot>img');
    var homes = null;

    function measureHomes() {
      for (var i = 0; i < pinChips.length; i++) pinChips[i].style.transform = '';
      var c = heroImg.getBoundingClientRect();
      var cx = c.left + c.width / 2, cy = c.top + c.height / 2;
      homes = pinChips.map(function (chip) {
        var r = chip.getBoundingClientRect();
        var hx = r.left + r.width / 2, hy = r.top + r.height / 2;
        /* home->center vector; distances are rigid inside the sticky box */
        return { dx: cx - hx, dy: cy - hy };
      });
    }

    /* Segment phases: glide in (0 -> P_IN), HOLD (P_IN -> P_OUT: the chip
       sticks at center and slowly swells to 1.5x while you keep scrolling),
       glide home (P_OUT -> 1). Widen the hold by moving P_IN/P_OUT apart. */
    var P_IN = 0.26, P_OUT = 0.74;
    function smoothstep(x) {
      x = Math.min(1, Math.max(0, x));
      return x * x * (3 - 2 * x);
    }

    function pinTarget() {
      var rect = pinWrap.getBoundingClientRect();
      var extra = pinWrap.offsetHeight - window.innerHeight;
      return extra > 0 ? Math.min(1, Math.max(0, -rect.top / extra)) : 0;
    }

    /* Each chip's animated position u (0 = home, 1 = centered) chases the
       scroll-derived target at a CAPPED speed — a full transit always takes
       ~TRANSIT ms. Slow scrolling stays under the cap, so it scrubs 1:1 with
       your finger; a fast flick hits the cap and plays the same calm
       animation instead of teleporting. */
    var TRANSIT = 450;                                /* ms for a full home<->center trip */
    var uShow = pinChips.map(function () { return 0; });
    /* per-chip scale reach: arrives at 1 + 0.3 = 1.3x, swells to 1 + 0.5 = 1.5x
       across the hold; remembered per chip so the glide home starts from
       whatever size the hold reached (no snap at the boundary) */
    var exShow = pinChips.map(function () { return 0.3; });

    function pinApply(p, dt) {
      if (!homes) measureHomes();
      var n = SPOTLIGHT.length;
      var seg = Math.min(n - 1, Math.floor(p * n));
      var t = p * n - seg;
      var lead = SPOTLIGHT[seg];
      var maxStep = dt / TRANSIT;
      for (var i = 0; i < pinChips.length; i++) {
        var uT = 0;
        if (i === lead && p < 1 && p > 0) {
          if (t < P_IN) {
            uT = smoothstep(t / P_IN);
            exShow[i] = 0.3;
          } else if (t > P_OUT) {
            uT = smoothstep((1 - t) / (1 - P_OUT));
          } else {
            /* THE HOLD — pinned at center; scrolling only feeds the swell */
            uT = 1;
            exShow[i] = 0.3 + 0.2 * ((t - P_IN) / (P_OUT - P_IN));
          }
        }
        var d = uT - uShow[i];
        uShow[i] += Math.max(-maxStep, Math.min(maxStep, d));
        if (Math.abs(uT - uShow[i]) < 0.004) uShow[i] = uT;
        var u = uShow[i];
        if (u <= 0.004) {
          uShow[i] = 0;
          exShow[i] = 0.3;
          pinChips[i].style.transform = '';
          pinChips[i].classList.remove('lead');
          continue;
        }
        var h = homes[i];
        var R0 = Math.sqrt(h.dx * h.dx + h.dy * h.dy);
        var A0 = Math.atan2(-h.dy, -h.dx);           /* angle of home around center */
        var R = R0 * (1 - u);
        var A = A0 + u * 1.9;                        /* ~110° sweep on the way in */
        var offX = h.dx + R * Math.cos(A);
        var offY = h.dy + R * Math.sin(A);
        pinChips[i].style.transform = 'translate(' + offX.toFixed(1) + 'px,' +
          offY.toFixed(1) + 'px) scale(' + (1 + u * exShow[i]).toFixed(3) + ')';
        pinChips[i].classList.add('lead');
      }
    }

    /* Continuous loop with an exponential chase: mouse wheels and trackpad
       flicks deliver scroll in steps, and driving the transform straight
       from those steps is what felt clunky. Instead the loop runs every
       frame while the hero is on screen and eases the animated progress
       toward the real scroll position (~90ms time constant), turning the
       stepped input into one fluid motion. Time-corrected so it behaves
       the same at any refresh rate. */
    var pSmooth = 0, pinRAF = null, lastTs = 0;
    function pinLoop(ts) {
      pinRAF = window.requestAnimationFrame(pinLoop);
      var dt = lastTs ? Math.min(64, ts - lastTs) : 16;
      lastTs = ts;
      var target = pinTarget();
      pSmooth += (target - pSmooth) * (1 - Math.exp(-dt / 90));
      if (Math.abs(target - pSmooth) < 0.003) pSmooth = target;  /* <1px — settle, don't creep */
      pinApply(pSmooth, dt);
    }
    function startLoop() {
      if (pinRAF === null) { lastTs = 0; pSmooth = pinTarget();
        pinRAF = window.requestAnimationFrame(pinLoop); }
    }
    function stopLoop() {
      if (pinRAF !== null) { window.cancelAnimationFrame(pinRAF); pinRAF = null;
        pinApply(pinTarget(), 1e9); }   /* snap clean so nothing freezes mid-arc */
    }
    if ('IntersectionObserver' in window) {
      /* only burn frames while the pinned hero is actually on screen */
      new IntersectionObserver(function (entries) {
        entries[0].isIntersecting ? startLoop() : stopLoop();
      }).observe(pinWrap);
    } else {
      startLoop();
    }
    window.addEventListener('resize', function () { homes = null; }, { passive: true });
  }

  /* While the offer is live, the sticky CTA carries you to the claim panel and
     focuses the zip field (the panel is the one place that can grant the offer).
     Once expired it reverts to a plain link into the wizard. */
  var stickyClaim = document.getElementById('stickyclaim');
  if (stickyClaim && claimIn) {
    stickyClaim.addEventListener('click', function (e) {
      var panel = document.getElementById('offerpanel');
      if (!panel || panel.getAttribute('data-state') !== 'live') return;
      e.preventDefault();
      panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      window.setTimeout(function () { claimIn.focus({ preventScroll: true }); }, reduce ? 0 : 520);
    });
  }

  var sticky = document.getElementById('stickycta');
  var hero = document.querySelector('.hero');
  var pageFooter = document.querySelector('footer');
  /* slide away while the footer is on screen so it never sits on top of it */
  if (sticky && pageFooter && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('dock', entries[0].isIntersecting);
    }, { threshold: 0 }).observe(pageFooter);
  }
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0, rootMargin: '-120px 0px 0px 0px' }).observe(hero);
  } else if (sticky) {
    sticky.classList.add('show');
  }
})();
